import { Body, Button } from 'copilot-design-system';

import {
  widgetButtonStyles,
  WidgetContainer,
  WidgetContent,
  WidgetDraft,
  WidgetHeader,
} from 'src/features/assistant/action-item/Widget';
import { CTA } from 'src/types/stream-chat';

const feedbackButtons = [
  'Shorten',
  'Lengthen',
  'Simplify',
  'Fix grammar',
  'Rewrite in my voice',
] as const;

export const MessageDraft = ({
  cta,
  handleCTAClick,
}: {
  cta: CTA;
  handleCTAClick: (cta: CTA) => void;
}) => {
  if (
    !cta.prefilled_data?.body ||
    typeof cta.prefilled_data.body !== 'string'
  ) {
    console.error('MessageDraft did not receive a valid message body');
    return null;
  }

  return (
    <>
      <WidgetContainer className="mb-5">
        <WidgetHeader
          widgetName="MESSAGE DRAFT"
          buttonName="Insert message"
          buttonIcon="Insert"
          onClick={() => handleCTAClick(cta)}
        />
        <WidgetContent>
          <WidgetDraft>
            <Body>{cta.prefilled_data.body}</Body>
          </WidgetDraft>
        </WidgetContent>
      </WidgetContainer>
      <div className="flex flex-items flex-wrap gap-2">
        {feedbackButtons.map((label) => (
          // TODO: implement onClick
          <Button
            key={label}
            className={widgetButtonStyles}
            variant="secondary"
            label={label}
          />
        ))}
      </div>
    </>
  );
};
